module.exports = __webpack_public_path__ + "static/img/fingerpost_refund_9.fe8c357.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_refund_9.jpg
// module id = nFdW
// module chunks = 0